export const NOTIFICATION_ICONS = {
  eye: 'ph:eye-light',
  chat: 'basil:chat-outline',
  document: 'carbon:document',
  hammer: 'mdi:court-hammer',
  transport: 'eva:car-outline',
  search: 'clarity:search-line',
}
